<template>
  <div>
    <pageTable 
      ref="table"
      :tableTitle="tableColumn"
      :searchData="searchData"
      tableApi="admin/shell_order_record/getLists"
    >
      <template v-slot:searchFormItem>
        <FormItem prop="order_id">
          <Input type="text" v-model="searchData.order_id" placeholder="订单ID" class="lx-search-item"></Input>
        </FormItem>
        <FormItem prop="pan_code">
          <Input type="text" v-model="searchData.pan_code" placeholder="卡号" class="lx-search-item"></Input>
        </FormItem>
        <FormItem prop="verification_status">
          <Select v-model="searchData.verification_status" placeholder="核销状态" style="width: 120px;">
            <Option value="">全部</Option>
            <Option value="0">待核销</Option>
            <Option value="1">已核销</Option>
            <Option value="2">核销失败</Option>
            <Option value="3">已取消</Option>
          </Select>
        </FormItem>
        <FormItem prop="is_normal">
          <Select v-model="searchData.is_normal" placeholder="是否正常" style="width: 120px;">
            <Option value="">全部</Option>
            <Option value="1">正常</Option>
            <Option value="0">异常</Option>
          </Select>
        </FormItem>
        <FormItem prop="time_range">
          <DatePicker 
            v-model="searchData.time_range" 
            type="daterange" 
            placeholder="时间范围" 
            style="width: 200px"
            format="yyyy-MM-dd"
          ></DatePicker>
        </FormItem>
      </template>

      <template v-slot:otherBtn>
        <FormItem>
          <Button type="warning" @click="exportRecords">导出</Button>
        </FormItem>
      </template>
    </pageTable>

    <!-- 详情对话框 -->
    <Modal
      v-model="showDetailModal"
      title="订单详情"
      width="900"
      :mask-closable="true"
    >
      <div v-if="detailData" class="detail-content">
        <Divider orientation="left">订单基本信息</Divider>
        <Row :gutter="16">
          <Col span="12">
            <p><strong>订单ID:</strong> {{ detailData.order_id }}</p>
            <p><strong>订单编号:</strong> {{ detailData.order_no || '-' }}</p>
            <p><strong>用户手机号:</strong> {{ detailData.user_mobile_display || detailData.user_mobile || '-' }}</p>
            <p><strong>车牌号:</strong> {{ detailData.car_number || '-' }}</p>
            <p><strong>站点名称:</strong> {{ detailData.gas_name || '-' }}</p>
          </Col>
          <Col span="12">
            <p><strong>订单金额(元):</strong> <Tag color="blue">{{ detailData.order_amount || '-' }}</Tag></p>
            <p><strong>订单状态:</strong> {{ detailData.order_status_text || '-' }}</p>
            <p><strong>退款状态:</strong> {{ detailData.refund_status_text || '-' }}</p>
            <p><strong>平台:</strong> {{ detailData.platform || '-' }}</p>
          </Col>
        </Row>

        <Divider orientation="left">壳牌虚拟卡信息</Divider>
        <Row :gutter="16">
          <Col span="12">
            <p><strong>卡号:</strong> {{ detailData.pan_code_display || detailData.pan_code || '-' }}</p>
          </Col>
          <Col span="12">
            <p><strong>初始余额:</strong> <Tag color="green">{{ detailData.initial_balance || '-' }} 元</Tag></p>
            <p><strong>最终余额:</strong> <Tag color="orange">{{ detailData.final_balance || '-' }} 元</Tag></p>
          </Col>
        </Row>

        <Divider orientation="left">扣款与核销信息</Divider>
        <Row :gutter="16">
          <Col span="12">
            <p><strong>实际扣款(元):</strong> <Tag color="blue">{{ detailData.actual_deduction || '-' }}</Tag></p>
            <p><strong>订单金额(元):</strong> <Tag color="cyan">{{ detailData.order_amount || '-' }}</Tag></p>
            <p>
              <strong>金额差异(元):</strong>
              <Tag :color="getAmountDiffColor(detailData.amount_difference)">
                {{ detailData.amount_difference || '0' }}
              </Tag>
            </p>
          </Col>
          <Col span="12">
            <p>
              <strong>核销状态:</strong> 
              <Tag :color="getVerificationStatusColor(detailData.verification_status)">
                {{ detailData.verification_status_text || '-' }}
              </Tag>
            </p>
            <p>
              <strong>是否正常:</strong> 
              <Tag :color="detailData.is_normal === 1 ? 'success' : 'error'">
                {{ detailData.is_normal_text || '-' }}
              </Tag>
            </p>
            <p><strong>核销时间:</strong> {{ detailData.verification_time || '-' }}</p>
          </Col>
        </Row>

        <Divider orientation="left">二维码有效期</Divider>
        <Row :gutter="16" v-if="detailData.qrcode_expire_time">
          <Col span="12">
            <p><strong>过期时间:</strong> {{ detailData.qrcode_expire_time }}</p>
            <p>
              <strong>是否过期:</strong> 
              <Tag :color="detailData.qrcode_expired === 1 ? 'error' : 'success'">
                {{ detailData.qrcode_expired === 1 ? '已过期' : '未过期' }}
              </Tag>
            </p>
          </Col>
          <Col span="12" v-if="detailData.qrcode_remaining_seconds !== undefined">
            <p>
              <strong>剩余时间:</strong> 
              <Tag :color="getRemainingTimeColor(detailData.qrcode_remaining_seconds)">
                {{ detailData.qrcode_remaining_text || '-' }}
              </Tag>
            </p>
          </Col>
        </Row>

        <Divider orientation="left">其他信息</Divider>
        <Row :gutter="16">
          <Col span="12">
            <p><strong>创建时间:</strong> {{ detailData.create_time }}</p>
            <p v-if="detailData.hours_since_created !== undefined">
              <strong>距今:</strong> {{ detailData.hours_since_created }} 小时
            </p>
          </Col>
          <Col span="12">
            <p v-if="detailData.verification_time && detailData.hours_since_verified !== undefined">
              <strong>核销距今:</strong> {{ detailData.hours_since_verified }} 小时
            </p>
          </Col>
        </Row>

        <Row v-if="detailData.remark">
          <Col span="24">
            <p><strong>备注:</strong> {{ detailData.remark }}</p>
          </Col>
        </Row>

        <Row v-if="detailData.yunying_mark">
          <Col span="24">
            <p><strong>处理结果:</strong> {{ detailData.yunying_mark }}</p>
          </Col>
        </Row>
      </div>

<!--      <div slot="footer">-->
<!--        <Button @click="showDetailModal = false">关闭</Button>-->
<!--        <Button -->
<!--          type="primary" -->
<!--          @click="recheckVerification" -->
<!--          :loading="recheckLoading"-->
<!--        >-->
<!--          重新检测-->
<!--        </Button>-->
<!--      </div>-->
    </Modal>

    <!-- 处理结果对话框 -->
    <Modal
      v-model="showMarkModal"
      title="订单处理结果"
      width="480"
      :mask-closable="true"
    >
      <Input
        v-model="markContent"
        type="textarea"
        :rows="4"
        :maxlength="500"
        show-word-limit
        placeholder="请输入处理结果内容"
      />
      <div slot="footer">
        <Button @click="showMarkModal = false">取消</Button>
        <Button type="primary" :loading="markLoading" @click="saveMark">确定</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import pageTable from "@/components/table/pageTable";
import shellCardApi from "@/api/shellCard";

export default {
  name: "shell-order-lists",
  components: { pageTable },
  data() {
    return {
      // 搜索数据
      searchData: {
        order_id: '',
        pan_code: '',
        verification_status: '',
        is_normal: '',
        time_range: [],
        start_time: '',
        end_time: ''
      },
      
      // 表格列定义
      tableColumn: [
        { title: '订单ID', key: 'order_id', align: 'center', width: 85 },
        /*{
          title: '订单编号', 
          key: 'order_no', 
          align: 'center',
          render: (h, params) => {
            return h('span', params.row.order_no || '-')
          }
        },*/
        { 
          title: '卡号', 
          key: 'pan_code', 
          align: 'center',
          render: (h, params) => {
            return h('span', params.row.pan_code_display || params.row.pan_code || '-')
          }
        },
        {
          title: '用户手机', 
          key: 'user_mobile', 
          align: 'center',
          render: (h, params) => {
            return h('span', params.row.user_mobile_display || params.row.user_mobile || '-')
          }
        },
        { title: '车牌号', key: 'car_number', align: 'center', width: 70 },
        {title:'站点',key:'gas_name',width:85,align:'center',render:(h,params)=>{
            return h('div',[
              h('p',params.row.gas_name),
              // h('Tag',{props:{color:'orange'}},params.row.platform),
            ])
          }},
        { 
          title: '订单金额(元)',
          key: 'pay_price', 
          align: 'center',
          render: (h, params) => {
            return h('Tag', { props: { color: 'blue' } }, params.row.order_amount)
          }
        },
        { 
          title: '实际扣款(元)',
          key: 'actual_deduction', 
          align: 'center',
          render: (h, params) => {
            return h('Tag', { props: { color: 'cyan' } }, params.row.actual_deduction)
          }
        },
        { 
          title: '金额差异(元)',
          key: 'amount_difference', 
          align: 'center',
          render: (h, params) => {
            const diff = parseFloat(params.row.amount_difference || 0)
            const color = Math.abs(diff) > 0.01 ? 'error' : 'success'
            return h('Tag', { props: { color } }, diff.toFixed(2))
          }
        },
        {
          title: '备注',
          key: 'remark',
          align: 'center',
          width: 130,
          render: (h, params) => {
            return h('p', params.row.remark)
          }
        },
        {
          title: '处理结果',
          key: 'yunying_mark',
          align: 'center',
          width: 130,
          render: (h, params) => {
            return h('p', params.row.yunying_mark || '-')
          }
        },
        { 
          title: '核销状态', 
          key: 'verification_status', 
          align: 'center',
          width: 110,
          render: (h, params) => {
            return h('Tag', { 
              props: { color: this.getVerificationStatusColor(params.row.verification_status) } 
            }, params.row.verification_status_text)
          }
        },
        { 
          title: '是否正常', 
          key: 'is_normal', 
          align: 'center',
          render: (h, params) => {
            return h('Tag', { 
              props: { color: params.row.is_normal === 1 ? 'success' : 'error' } 
            }, params.row.is_normal_text)
          }
        },
        // {
        //   title: '二维码剩余时间',
        //   key: 'qrcode_remaining_text',
        //   align: 'center',
        //   width: 80,
        //   render: (h, params) => {
        //     if (!params.row.qrcode_remaining_text) return h('span', '-')
        //     return h('Tag', {
        //       props: { color: this.getRemainingTimeColor(params.row.qrcode_remaining_seconds) }
        //     }, params.row.qrcode_remaining_text)
        //   }
        // },
        { title: '创建时间', key: 'create_time', align: 'center', width: 110 },
        { title: '核销时间', key: 'verification_time', align: 'center', width: 110 },
        { 
          title: '操作', 
          align: 'center', 
          width: 170,
          render: (h, params) => {
            return h('div', [
              h('Button', {
                props: { type: 'primary', size: 'small' },
                style: { marginRight: '5px' },
                on: { click: () => { this.showDetail(params.row) } }
              }, '详情'),
              h('Button', {
                props: { type: 'warning', size: 'small' },
                on: { click: () => { this.openMarkModal(params.row) } }
              }, '处理结果'),
              // h('Button', {
              //   props: { type: 'warning', size: 'small' },
              //   on: { click: () => { this.recheckVerification(params.row) } }
              // }, '重新检测')
            ])
          }
        }
      ],
      
      // 详情相关
      showDetailModal: false,
      detailData: null,
      recheckLoading: false,

      // 处理结果相关
      showMarkModal: false,
      markContent: '',
      markRow: null,
      markLoading: false
    }
  },
  methods: {
    // 获取核销状态颜色
    getVerificationStatusColor(status) {
      const colorMap = {
        0: 'default',    // 待核销
        1: 'success',    // 已核销
        2: 'error',      // 核销失败
        3: 'warning'     // 已取消
      }
      return colorMap[status] || 'default'
    },
    
    // 获取金额差异颜色
    getAmountDiffColor(difference) {
      const diff = parseFloat(difference || 0)
      return Math.abs(diff) > 0.01 ? 'error' : 'success'
    },
    
    // 获取剩余时间颜色
    getRemainingTimeColor(seconds) {
      if (seconds === undefined || seconds === null) return 'default'
      if (seconds <= 0) return 'error'
      if (seconds <= 60) return 'warning'
      return 'success'
    },
    
    // 显示详情
    async showDetail(row) {
      try {
        const res = await shellCardApi.getOrderDetail({ order_id: row.order_id })
        if (res.code === 200) {
          this.detailData = res.data
          this.showDetailModal = true
        } else {
          this.$Message.error(res.msg || '获取详情失败')
        }
      } catch (error) {
        this.$Message.error('获取详情失败')
        console.error(error)
      }
    },
    
    // 重新检测核销状态
    async recheckVerification(row) {
      this.$Modal.confirm({
        title: '重新检测',
        content: `确定要重新检测订单 ${row.order_id} 的核销状态吗？`,
        loading: true,
        onOk: async () => {
          try {
            const res = await shellCardApi.recheckVerification({ order_id: row.order_id })
            this.$Modal.remove()
            if (res.code === 200) {
              this.$commonFun.successTip(res.msg || '检测完成', () => {
                this.$refs.table.getLists()
                // 如果详情弹窗打开，刷新详情
                if (this.showDetailModal && this.detailData) {
                  this.showDetail(this.detailData)
                }
              })
            } else {
              this.$Message.error(res.msg || '检测失败')
            }
          } catch (error) {
            this.$Modal.remove()
            this.$Message.error('检测失败')
            console.error(error)
          }
        }
      })
    },
    
    // 打开处理结果弹窗
    openMarkModal(row) {
      this.markRow = row
      this.markContent = row.yunying_mark || ''
      this.showMarkModal = true
    },

    // 保存处理结果
    async saveMark() {
      const content = (this.markContent || '').trim()
      if (!content) {
        this.$Message.warning('请输入处理结果内容')
        return
      }
      this.markLoading = true
      try {
        const res = await shellCardApi.saveMark({
          order_id: this.markRow.order_id,
          yunying_mark: content
        })
        if (res.code === 200) {
          this.showMarkModal = false
          this.$commonFun.successTip(res.msg || '保存成功', () => {
            this.$refs.table.getLists()
          })
        } else {
          this.$Message.error(res.msg || '保存失败')
        }
      } catch (error) {
        this.$Message.error('保存失败')
        console.error(error)
      }
      this.markLoading = false
    },

    // 导出记录
    exportRecords() {
      this.$Modal.confirm({
        title: '导出确认',
        content: '确定要导出当前筛选条件下的订单记录吗？（最多1万条）',
        loading: true,
        onOk: async () => {
          try {
            // 处理时间范围
            const params = { ...this.searchData }
            if (params.time_range && params.time_range.length === 2) {
              params.start_time = this.formatDate(params.time_range[0])
              params.end_time = this.formatDate(params.time_range[1])
            }
            delete params.time_range
            
            // 构建URL参数
            const queryString = Object.keys(params)
              .filter(key => params[key] !== '' && params[key] !== null && params[key] !== undefined)
              .map(key => `${key}=${encodeURIComponent(params[key])}`)
              .join('&')
            
            const url = `${this.$config.API_PATH}admin/shell_order_record/exportRecords?${queryString}`
            window.open(url, '_blank')
            
            this.$Modal.remove()
            this.$Message.success('导出任务已开始')
          } catch (error) {
            this.$Modal.remove()
            this.$Message.error('导出失败')
            console.error(error)
          }
        }
      })
    },
    
    // 格式化日期
    formatDate(date) {
      if (!date) return ''
      const d = new Date(date)
      const year = d.getFullYear()
      const month = String(d.getMonth() + 1).padStart(2, '0')
      const day = String(d.getDate()).padStart(2, '0')
      return `${year}-${month}-${day}`
    }
  },
  watch: {
    // 监听时间范围变化
    'searchData.time_range': function(val) {
      if (val && val.length === 2) {
        this.searchData.start_time = this.formatDate(val[0])
        this.searchData.end_time = this.formatDate(val[1])
      } else {
        this.searchData.start_time = ''
        this.searchData.end_time = ''
      }
    }
  }
}
</script>

<style scoped lang="less">
.detail-content {
  p {
    margin-bottom: 10px;
    line-height: 1.6;
    
    strong {
      display: inline-block;
      width: 100px;
      font-weight: bold;
    }
  }
}
</style>
